import profile from '../other/profile';
import additionalCost from '../shared/additionalCost';
import additionalDocument from '../shared/additionalDocument';
import address from '../shared/address';
import bill from '../shared/bill';
import contact from '../shared/contact';
import discount from '../shared/discount';
import document from '../shared/document';
import notes from '../shared/notes';
import payment from '../shared/payment';
import paymentDocument from '../shared/paymentDocument';
import rentalObject from '../shared/rentalObject';

const mietpreisbremse = `
    additionalCosts {
        ${additionalCost}
    }
    additionalDocuments {
        ${additionalDocument}
    }
    agreement {
        ${document}
    }
    apartmentQuestions {
        negative {
            badElectrics
            badFloorplan
            noBalcony
            noWashingMachinePossible
            singleGlazing
            visibleDrainage
            visibleElectrics
        }
        positive {
            barrierFree
            coldWaterMeter
            doorAlarm
            elaborateCeilingWallCladding
            hiddenHeatingPipes
            highQualityFlooring
            insulatedGlazing
            largeBalcony
            largeLivingRoom
            shutters
            storageRoom
            underfloorHeating
        }
    }
    bankAccount {
        iban
        id
        name
    }
    bankAccountId
    bathroom
    bathroomQuestions {
        negative {
            floorboards
            insufficientHotWater
            noAdditionalShower
            noHeating
            noneOrSmallSink
            noShower
            noVentilation
            noWindows
            smallBathroom
            splashGuards
        }
        positive {
            highQualityFittings
            highQualityFlooring
            largeBathroom
            largeSink
            modernVentilation
            recessedCistern
            separateToilet
            splitShower
            structuralRadiators
            underfloorHeating
        }
    }
    billingAddress {
        ${address}
    }
    billingAddressId
    billings {
        ${bill}
    }
    billReportBasePrice
    caseHeros
    caseId
    complaint {
        ${document}
    }
    created
    debtorLawyer {
        ${contact}
        caseNumber
    }
    depositDiff
    discountId
    discount {
        ${discount}
    }
    environment
    environmentQuestions {
        negative {
            neglected
            noBicycleStorage
            noisy
            smelly
        }
        positive {
            city
            garden
            highQuality
            parking
            quiet
        }
    }
    finished
    firstComplaint
    firstTimeRentedAfterOct2014
    gotTextualConfirmModernization
    gotTextualConfirmPrerent
    id
    incomingPayments {
        ${payment}
        #externalReference {
        #    id
        #}
    }
    inputCompleted
    inputOverview {
        ${document}
    }
    kitchen
    kitchenQuestions {
        negative {
            insufficientHotWater
            noCookingFacilities
            noDishwasherPossible
            noSink
            notHeatable
            noWindows
        }
        positive {
            extractorHood
            fitted
            fridge
            highQualityFlooring
            separateKitchen
            stove
        }
    }
    lastMail
    lastStatusChange
    monitions {
        ${paymentDocument}
    }
    monthlySaving
    nextDeadline
    ${notes}
    outgoingPayments {
        ${payment}
    }
    ownerSub
    partitionKey
    path
    productType
    profile {
        ${profile}
    }
    referrer {
        id
        referringPartner
    }
    rentalObject {
        ${rentalObject}
    }
    rentalObjectId
    report {
        ${document}
    }
    reportBasePrice
    requestsPayments {
        ${paymentDocument}
    }
    resubmissions {
        author
        message
        remember
    }
    sales
    signatures {
        id
        signature
        tenantId
    }
    status
    stepData {
        comparativeRent
        constructionYearRange
        discount
        residentialArea
    }
    textualConfirmModernization {
        ${document}
    }
    textualConfirmPrerent {
        ${document}
    }
    type
    warning
    yearOfConstruction
`;

export default mietpreisbremse;
